import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "@/utils/cookies";
import { useGetClientQuery } from "@/queries/useGetClientQuery";
import { useGetClientsArrQuery } from "@/queries/useGetClientsArrQuery";
import { closeAccordion } from "@/redux/slices/interfaceSlice";
import type { RootState } from "@/redux/types";

interface UserInfo {
  firstName: string;
  fullName: string;
  id: string;
  token: string;
}

export const useHeaderProfileBlock = () => {
  const dispatch = useDispatch();

  const userTokens: Array<string> = (() => {
    try {
      const tokens = getCookie("user_tokens");
      return tokens ? JSON.parse(tokens) : [];
    } catch {
      return [];
    }
  })();
  const { closeAccordionState } = useSelector((state: RootState) => state.interfaceApp);
  const { data: clientData, isPending, error } = useGetClientQuery();
  const { data: clientsResponses } = useGetClientsArrQuery(userTokens);

  const userId: string = useMemo(() => {
    if (clientData) return `${clientData.id}`;
    return "";
  }, [clientData]);

  const firstLetter: string = useMemo(() => {
    if (clientData) return `${clientData.name.charAt(0).toUpperCase()}`;
    return "";
  }, [clientData]);

  const userNames = useMemo<UserInfo[]>(() => {
    if (!clientsResponses) return [];

    return clientsResponses.map((response) => {
      const { name, last_name, id } = response.data.data;
      return {
        firstName: name,
        fullName: last_name ? `${name} ${last_name}` : name,
        id: id,
        token: response.token,
      };
    });
  }, [clientsResponses]);

  const [selectedUserId, setSelectedUserId] = useState(userId);
  useEffect(() => {
    setSelectedUserId(userId);
  }, [userId]);

  const closeAccordionToggle = () => {
    dispatch(closeAccordion(closeAccordionState * -1));
  };

  if (isPending)
    return {
      userName: "",
      userNames,
      firstLetter: "",
      selectedUserId,
      setSelectedUserId,
      isLoading: true,
      closeAccordionToggle,
    };

  if (error)
    return {
      userName: "Ошибка загрузки имени",
      userNames,
      firstLetter: "",
      selectedUserId,
      setSelectedUserId,
      isLoading: false,
      closeAccordionToggle,
    };
  return {
    userNames,
    firstLetter,
    selectedUserId,
    setSelectedUserId,
    isLoading: false,
    closeAccordionToggle,
  };
};
